import { render, staticRenderFns } from "./TemplateSelect.vue?vue&type=template&id=b5145558&scoped=true"
import script from "./TemplateSelect.vue?vue&type=script&lang=js"
export * from "./TemplateSelect.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelect.vue?vue&type=style&index=0&id=b5145558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5145558",
  null
  
)

export default component.exports